var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canViewHubSpot && _vm.url)?_c('div',{class:_vm.$style.wrapper,style:(`width: ${_vm.size}px; height: ${_vm.size}px;`),attrs:{"data-test-id":"hubspotButton"},on:{"click":_vm.goto}},[_c('el-image',{attrs:{"src":_vm.hubspotIcon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }